import { useEffect } from 'react';

export default function useFilterDismissal(open, setOpen) {
  useEffect(() => {
    if (!open) return undefined;
    const dismissOutside = event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (target?.closest('#news-filters, .toggle-filters-btn, .interest-prompt')) return;
      setOpen(false);
    };
    // A completed click works for mouse, touch and keyboard. Closing on press
    // can move the clicked control before release and swallow its action.
    document.addEventListener('click', dismissOutside, true);
    return () => document.removeEventListener('click', dismissOutside, true);
  }, [open, setOpen]);
}
